import React, {useState, useContext, useEffect, useCallback} from 'react';
import {Button, setOptions} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {Listview} from '@mobiscroll/react4';
import '@mobiscroll/react4/dist/css/mobiscroll.min.css';
import '../styles/queueWait.css';
import dayjs from "dayjs";
import {
    faUsersMedical,
    faQrcode,
    faAt,
    faMobileScreenButton,
    faCirclePhone,
    faClipboardList,
    faBrainCircuit,
    faUserPlus, faPipe
} from "@fortawesome/pro-duotone-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Empty from "../utils/Empty";
import User from "../utils/User";
import Loading from "../utils/Loading";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function QueueWait({locale, Dialog, setVisit, location, setPatient, width}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
    const [queueWait, setQueueWait] = useState([]);
    const [loading, setLoading] = useState(true);
    const [iconHover, setIconHover] = useState(null);

    const Queue = data => {
        const message = {
            type: 'wss',
            path: 'queue',
            action: 'get',
            data: {
                status: 'wait',
                location: location
            }
        };
        wsCall(message);
    }

    const ButtonQR = () => {

        const message = {
            type: 'wss',
            path: 'shortener-micro',
            action: 'put',
            data: {
                path: 'queueWait',
                type: 'qr',
                location: location,
                title: locale.queueWait.e,
                dialog: true
            }
        };
        wsCall(message);
    }

    const ButtonVisit = () => {
        setVisit({});
        Dialog({view: 'sharedNewMenu'});
    }

    const ButtonPatient = data => {
        setVisit(data);
        setPatient({});

        const message = {
            type: 'wss',
            path: 'patient',
            action: 'get',
            data: {
                patient: data.user,
                source: 'queueWait'
            }
        };
        wsCall(message);
    }

    const ClickOpen = data => {
        setVisit(data);
        Dialog({view: 'queueVisit', tab: 'visit'});
    }

    const ListItem = data => {
        const itemDate = dayjs(parseInt(data.item.timestampArrival)).format("MMMM D, YYYY @ h:mm A");

        return <li key={data.item.timestampArrival}>
            <div className="mbsc-row">
                <div className="mbsc-col">
                    <div className="mbsc-row cs-queue-wait-list" onClick={(ev) => ClickOpen(data.item)} >
                        {width > 576 && data.item.type === 'mobile' &&
                            <FontAwesomeIcon className="cs-queue-wait-list-icon-mobile" icon={faMobileScreenButton} />
                        }
                        {width > 576 && data.item.type === 'whatsapp' &&
                            <FontAwesomeIcon className="cs-queue-wait-list-icon-whatsapp" icon={faCirclePhone} />
                        }
                        {width > 576 && data.item.type === 'email' &&
                            <FontAwesomeIcon className="cs-queue-wait-list-icon-email" icon={faAt} />
                        }
                        <div className="cs-queue-wait-list-section">
                            <div className="mbsc-bold mbsc-txt-muted">
                                {data.item.firstName && data.item.firstName} {data.item.middleName && data.item.middleName} {data.item.lastName && data.item.lastName} {data.item.paternalName && data.item.paternalName} {data.item.maternalName && data.item.maternalName} {width > 992 && <FontAwesomeIcon className="cs-queue-wait-icon-pipe-xs" icon={faPipe} />} {width > 992 && User(data.item)} {data.item.triage.length !== 0 && <FontAwesomeIcon className="cs-queue-wait-icon-info" icon={faBrainCircuit} />}{data.item.firstVisit && <FontAwesomeIcon className="cs-queue-wait-icon-info" icon={faUserPlus} />}
                            </div>
                            <div className="mbsc-row mbsc-txt-muted mbsc-txt-s cs-queue-wait-item-txt">
                                {width > 992 && locale.queueWait.f} {itemDate}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mbsc-col-auto cs-queue-wait-list-button">
                    <Button color="primary" variant="flat" className="mbsc-bold" onClick={() => ButtonPatient(data.item)} >
                        <FontAwesomeIcon className="cs-queue-wait-icon-right" icon={faClipboardList} />
                    </Button>
                </div>
            </div>
        </li>;
    }

    const GetQueue = useCallback(data => {
        if (data.queue) {
            setQueueWait(data.queue);
        }
        if (loading) {
            setLoading(false);
        }
    }, [loading]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'queue') {
            GetQueue(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetQueue, setWsResponse]);

    useEffect(() => {
        Queue();
    }, []);

    return (
        <>
            <div className={width > 768 ? "mbsc-row cs-queue-wait-menu" : "mbsc-row cs-queue-wait-menu-xs"} >
                <div className="mbsc-col" />
                <div className="mbsc-col-auto">
                    <div className="mbsc-row">
                        <Button onMouseEnter={() => setIconHover('qr')} onMouseLeave={() => setIconHover(null)} color="primary" variant="flat" className="mbsc-bold cs-queue-wait-button-text" onClick={() => ButtonQR()} >
                            <FontAwesomeIcon className="cs-queue-wait-icon" icon={faQrcode} beatFade={iconHover === 'qr'} /> {width > 768 && locale.queueWait.c}
                        </Button>
                        <Button onMouseEnter={() => setIconHover('users')} onMouseLeave={() => setIconHover(null)} id="sharedNewMenu" color="primary" variant="flat" className="mbsc-bold cs-queue-wait-button-text" onClick={() => ButtonVisit()} >
                            <FontAwesomeIcon className="cs-queue-wait-icon" icon={faUsersMedical} beatFade={iconHover === 'users'} /> {width > 768 && locale.queueWait.b}
                        </Button>
                    </div>
                </div>
            </div>
            {loading &&
                <div className="mbsc-padding" >
                    <Loading />
                </div>
            }
            {queueWait.length === 0 && !loading &&
                <div className="mbsc-row mbsc-justify-content-center cs-queue-wait-section">
                    <div className="mbsc-padding">
                        <p className="mbsc-bold mbsc-txt-muted">{locale.queueWait.a}</p>
                    </div>
                </div>
            }
            {queueWait.length !== 0 && !loading &&
                <Listview
                    theme="ios"
                    themeVariant="light"
                    select="single"
                    itemType={ListItem}
                    data={queueWait}
                />
            }
        </>
    );
}

export default QueueWait;
